import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-candidate-added-to-pool',
  templateUrl: './activity-item-candidate-added-to-pool.component.html',
  styleUrls: ['./activity-item-candidate-added-to-pool.component.scss']
})
export class ActivityItemCandidateAddedToPoolComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;
  
  @Input()
  language: 'de' | 'en' = 'de';

  // in a candidate's own feed the candidate goes without saying
  @Input()
  context: string = null;

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }
}
